import { INTEGRATION_CONTACTS, extractIntegrationConfigurations } from './integrationConfigurationUtils';
import { ICloudConfig } from './integrationTypes';

export const INTEGRATION_LOGIN_ICLOUD_APPLE_ID = 'appleId';
export const INTEGRATION_LOGIN_ICLOUD_APPLE_SPECIFIC_PASSWORD = 'appSpecificPassword';
export const INTEGRATION_CONFIG_ICLOUD_SYNC_TOKEN = 'syncToken';

export const INTEGRATION_CONFIG_ICLOUD: ICloudConfig = {
  CONTACTS: { name: INTEGRATION_CONTACTS, defaultValue: 'true' },
};

export const icloudDefaultConfigurations = {
  ...extractIntegrationConfigurations(INTEGRATION_CONFIG_ICLOUD),
  [INTEGRATION_LOGIN_ICLOUD_APPLE_ID]: '',
  [INTEGRATION_LOGIN_ICLOUD_APPLE_SPECIFIC_PASSWORD]: '',
  [INTEGRATION_CONFIG_ICLOUD_SYNC_TOKEN]: '',
};
